import { render } from "./Index_contact_en_m.vue?vue&type=template&id=4b0cdee0&scoped=true"
import script from "./Index_contact_en_m.vue?vue&type=script&lang=js"
export * from "./Index_contact_en_m.vue?vue&type=script&lang=js"

import "./Index_contact_en_m.vue?vue&type=style&index=0&id=4b0cdee0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4b0cdee0"

export default script